import { render, staticRenderFns } from "./PartnerInfoData.vue?vue&type=template&id=1c494450&scoped=true"
import script from "./PartnerInfoData.vue?vue&type=script&lang=js"
export * from "./PartnerInfoData.vue?vue&type=script&lang=js"
import style0 from "./PartnerInfoData.vue?vue&type=style&index=0&id=1c494450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c494450",
  null
  
)

export default component.exports